import { useState, useEffect, useContext } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import Modal from "../../components/Modal";
import CustomButton from "../../components/CustomButton";
import CustomInput from "../../components/CustomInput";
import useLanguage from "../../utils/useLanguage";
// import nextIcon from "../../assets/next_icon.png";
// import previousIcon from "../../assets/previous_icon.png";
// import editIcon from "../../assets/edit_icon.png";
// import closeIcon from "../../assets/close_icon.png";
// import saveIcon from "../../assets/save_icon.png";
// import addIcon from "../../assets/add_icon.png";
import { UserAuth } from "../../utils/AuthContext";
import Loader from "../../components/Loader";
import ErrorBox from "../../components/ErrorBox";
import { DataContext } from "../../utils/DataContext";
import BackToDashboard from "../../components/BackToDashboard";
import BankAccountSection from "./BankAccountSection";
import SectionDivider from "../../components/SectionDivider";
import DashboardSection from "../../components/DasboardSection";
import SubCompanyAdditionalInfoSection from "../../components/SubCompanyAddtionalInfoSection";
import { formatDate, toDate } from "../../utils/toDate";
import AreYouSureModal from "../../components/AreYouSureModal";
import { shouldCloseModal } from "../../utils/shouldCloseModal";
import CollapsibleCard from "../attendance-system/CollapsibleCard";
import SectionDividerWithNoLine from "../../components/SectionDividerWithNoLine";
import PageWrapper from "../../components/PageWrapper";

export default function SubCompanies() {
  const { t } = useTranslation("general");
  const { currentDirection } = useLanguage();
  const [filteredSubCompanies, setFilteredSubCompanies] = useState([]);
  // const [networkError, setNetworkError] = useState(false);
  const [subCompanyModal, setSubCompanyModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [subCompanyFields, setSubCompanyFields] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loadingModal, setLoadingModal] = useState(false);

  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [duplicateAccountNumber, setDuplicateAccountNumber] = useState("");

  const [showAreYouSure, setShowAreYouSure] = useState(false);
  const [showUpdateAreYouSure, setShowUpdateAreYouSure] = useState(false);

  const [addSubCompanyModal, setAddSubCompanyModal] = useState(false);
  const [newSubCompanyFields, setNewSubCompanyFields] = useState({
    companyName: "",
    nameInAr: "",
    address: "",
    city: "",
    country: "",
    location: "",
    website: "",
    idNumber: "",
    customsCode: "",
    email: "",
    phoneNumber: "",
    organizationId: "",
    nearestLandmark: "",
    bankAccounts: [],
  });

  const [additionalInfoState, setAdditionalInfoState] = useState({
    // Basic company information
    addressInAr: "",
    countryCode: "",
    BusinessSector: "",
    typeOfGoods: "",
    commercialCompanyType: "",
    certificateIssueDate: new Date(),
    registrationNumber: "",
    originatorType: "",
    generalPurpose: "",
    purposeDetails: "",
    supplier1: "",
    supplier2: "",
    supplier3: "",
    estimatedPaymentsCountPerQuarter: "",
    estimatedPaymentsValuePerQuarter: "",
    numberOfEmployees: "",
    annualRevenue: "",

    // Senior Managing Official Data
    sFirstName: "",
    sLastName: "",
    sFirstNameInAr: "",
    sLastNameInAr: "",
    sDateOfBirth: new Date(),
    sPhoneNumber: "",
    sAddress: "",
    sCity: "",
    sCountry: "",
    sPosition: "",
    sIsOwner: "",
    sOwnerPercentage: "",
    sIsAuthorizedSignatory: "",
    sidType: "",

    // Authorized Signatory Data
    aFirstName: "",
    aLastName: "",
    aFirstNameInAr: "",
    aLastNameInAr: "",
    aDateOfBirth: new Date(),
    aPhoneNumber: "",
    aAddress: "",
    aCity: "",
    aCountry: "",
    aIsOwner: "",
    aOwnerPercentage: "",
    aIsAuthorizedSeniorManaging: "",
    aIdType: "",
    aIdNumber: "",
  });

  const [addBankAccountFields, setAddBankAccountFields] = useState({
    visible: true,
    count: 0,
  });

  const { userData } = useContext(UserAuth);
  const {
    getSubCompanies,
    subCompanies,
    selectedSubCompany,
    setSelectedSubCompany,
    loading,
    setLoading,
    // searchTerm,
    // setSearchTerm,
  } = useContext(DataContext);

  const [searchTerm, setSearchTerm] = useState("");

  const emptyInputField =
    errorMessage === "emptyInputFields" ? "emptyInputField" : null;
  useEffect(() => {
    const req = async () => {
      const res = await getSubCompanies(currentPage);
      if (res?.status === 200) {
        setTotalPages(res?.data?.totalPages);
        setTotalRecords(res?.data?.totalSubCompanies);
      }
    };

    req();
  }, [currentPage, userData?.token, userData?.organizationId]);

  useEffect(() => {
    setFilteredSubCompanies(
      subCompanies?.filter((subCompany) =>
        subCompany?.name?.toLowerCase().includes(searchTerm?.toLowerCase())
      )
    );
  }, [searchTerm, subCompanies]);

  const openSubCompanyModal = (subCompany) => {
    setSelectedSubCompany(subCompany);
    setSubCompanyFields({
      companyName: subCompany?.name,
      nameInAr: subCompany?.nameInAr,
      address: subCompany?.address,
      website: subCompany?.website,
      email: subCompany?.email,
      phoneNumber: subCompany?.phoneNumber,
      idNumber: subCompany?.idNumber,
      customsCode: subCompany?.customsCode,
      nearestLandmark: subCompany?.nearestLandmark,
      compSupAdditionalInfo: subCompany?.comSupAdditionalInfo,
      country: subCompany?.country,
      city: subCompany?.city,
    });

    setIsEditing(false); // Set to editing mode
    setSubCompanyModal(true);
  };

  const handleInputChange = (e, fieldName) => {
    setError(false);
    setErrorMessage("");
    setSubCompanyFields((prev) => ({
      ...prev,
      [fieldName]: e.target.value,
    }));
  };

  const handleNestedInputChange = (e, fieldName) => {
    setError(false);
    setErrorMessage("");
    setSubCompanyFields((prev) => ({
      ...prev,
      compSupAdditionalInfo: {
        ...prev.compSupAdditionalInfo,
        [fieldName]: e.target.value,
      },
    }));
  };

  const handleAttemptCancel = () => {
    setShowAreYouSure(true);
  };

  const handleAttemptCancelUpdate = () => {
    const hasData = shouldCloseModal(subCompanyFields);
    if (hasData) {
      handleCancel();
      return;
    } else {
      setShowUpdateAreYouSure(true);
    }
  };

  const handleSaveSubCompany = async () => {
    const token = localStorage.getItem("token");

    try {
      // Validate required fields
      const requiredFields = [
        subCompanyFields.companyName,
        subCompanyFields.nameInAr,
        subCompanyFields.address,
        subCompanyFields.city,
        subCompanyFields.country,
        subCompanyFields.phoneNumber,
        subCompanyFields.idNumber,
      ];

      if (requiredFields.some((field) => !field)) {
        setError(true);
        setErrorMessage("emptyInputFields");
        return;
      }

      // Email validation regex
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (subCompanyFields.email) {
        if (!emailPattern.test(subCompanyFields.email)) {
          setError(true);
          setErrorMessage("invalidEmail");
          return;
        }
      }

      setLoadingModal(true);
      const response = await axios.put(
        `${process.env.REACT_APP_URL}/api/subCompany/${selectedSubCompany.id}`,
        subCompanyFields,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "organization-Id": userData?.organizationId,
          },
        }
      );

      if (response.status === 200) {
        setSubCompanyModal(false);
      } else {
        console.error("Failed to update SubCompany:", response.data.message);
      }
      setLoadingModal(false);
    } catch (error) {
      const message = error?.response?.data?.message;
      const accountNumber = error?.response?.data?.accountNumber;

      setError(true);
      setErrorMessage(message || "unexpectedError");
      setDuplicateAccountNumber(accountNumber);
      console.error("Error updating SubCompany:", error);
      setLoadingModal(false);
    } finally {
      getSubCompanies();
    }
  };

  const handleCancel = () => {
    setLoadingModal(false);
    setSubCompanyModal(false);
    setSelectedSubCompany(null);
    setError(false);
    setErrorMessage("");
    setShowUpdateAreYouSure(false);
  };

  const openAddSubCompanyModal = () => {
    setAddSubCompanyModal(true);
    setNewSubCompanyFields({
      companyName: "",
      nameInAr: "",
      address: "",
      city: "",
      country: "",
      location: "",
      website: "",
      idNumber: "",
      customsCode: "",
      email: "",
      phoneNumber: "",
      organizationId: "",
      nearestLandmark: "",
      bankAccounts: [],
    });

    setAdditionalInfoState({
      // Basic company information
      addressInAr: "",
      countryCode: "",
      BusinessSector: "",
      typeOfGoods: "",
      commercialCompanyType: "",
      certificateIssueDate: null,
      registrationNumber: "",
      originatorType: "",
      generalPurpose: "",
      purposeDetails: "",
      supplier1: "",
      supplier2: "",
      supplier3: "",
      estimatedPaymentsCountPerQuarter: "",
      estimatedPaymentsValuePerQuarter: "",
      numberOfEmployees: "",
      annualRevenue: "",

      // Senior Managing Official Data
      sFirstName: "",
      sLastName: "",
      sFirstNameInAr: "",
      sLastNameInAr: "",
      sDateOfBirth: null,
      sPhoneNumber: "",
      sAddress: "",
      sCity: "",
      sCountry: "",
      sPosition: "",
      sIsOwner: "",
      sOwnerPercentage: "",
      sIsAuthorizedSignatory: "",
      sidType: "",

      // Authorized Signatory Data
      aFirstName: "",
      aLastName: "",
      aFirstNameInAr: "",
      aLastNameInAr: "",
      aDateOfBirth: null,
      aPhoneNumber: "",
      aAddress: "",
      aCity: "",
      aCountry: "",
      aIsOwner: "",
      aOwnerPercentage: "",
      aIsAuthorizedSeniorManaging: "",
      aIdType: "",
      aIdNumber: "",
    });
  };

  const handleNewSubCompanyInputChange = (e, fieldName) => {
    const value = fieldName === "isBlocked" ? e.target.checked : e.target.value;
    setError(false);
    setErrorMessage("");
    setNewSubCompanyFields((prevFields) => ({
      ...prevFields,
      [fieldName]: value,
    }));
  };

  const handleCreateSubCompany = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem("token");

    try {
      // Determine the language based on currentDirection
      const language = currentDirection === "rtl" ? "ar" : "en";

      const requiredFields = [
        newSubCompanyFields.companyName,
        newSubCompanyFields.nameInAr,
        newSubCompanyFields.address,
        newSubCompanyFields.city,
        newSubCompanyFields.country,
        newSubCompanyFields.phoneNumber,
        newSubCompanyFields.idNumber,
      ];

      if (requiredFields.some((field) => !field)) {
        setError(true);
        setErrorMessage("emptyInputFields");
        return;
      }

      // // Email validation regex
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (newSubCompanyFields.email) {
        if (!emailPattern.test(newSubCompanyFields.email)) {
          setError(true);
          setErrorMessage("invalidEmail");
          return;
        }
      }

      // Check if all additionalInfo fields are empty
      const hasNonEmptyAdditionalInfo = Object.entries(
        additionalInfoState
      ).some(([key, value]) => {
        if (value === null || value === undefined || value === "") {
          return false;
        }
        // Handle date fields
        if (key.includes("Date") && value instanceof Date) {
          return !isNaN(value.getTime()); // Check if valid date
        }
        return true;
      });

      const payload = {
        ...newSubCompanyFields,
        organizationId: Number(userData?.organizationId),
        userId: Number(userData?.userId),
        language,
      };

      // Only add additionalInfo if it has non-empty values
      if (hasNonEmptyAdditionalInfo) {
        payload.additionalInfo = {
          ...additionalInfoState,
          certificateIssueDate: additionalInfoState.certificateIssueDate
            ? new Date(additionalInfoState.certificateIssueDate)
            : null,
          sDateOfBirth: additionalInfoState.sDateOfBirth
            ? new Date(additionalInfoState.sDateOfBirth)
            : null,
          aDateOfBirth: additionalInfoState.aDateOfBirth
            ? new Date(additionalInfoState.aDateOfBirth)
            : null,
        };
      }

      setLoadingModal(true);
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/subCompany`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 201) {
        setError(false);
        setErrorMessage("");
        setAddSubCompanyModal(false);

        // * if the new subCompany added, fetch the data again.
        const getSubCompaniesRes = await getSubCompanies();
        if (getSubCompaniesRes.status === 200) {
          setTotalPages(getSubCompaniesRes?.data?.totalPages);
          setTotalRecords(getSubCompaniesRes?.data?.totalSubCompanies);
        }

        const storedSubCompany = JSON.parse(
          localStorage.getItem("subCompany")
        )?.id;

        if (!storedSubCompany) {
          const { id, name, nameInAr } = response?.data?.subCompany;
          localStorage.setItem(
            "subCompany",
            JSON.stringify({ id, name, nameInAr })
          );
        }
      }

      // setSubCompanies((prev) => [response?.data?.subCompany, ...prev]);
      setLoadingModal(false);
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        const errorKey = error.response.data.error;
        // Map backend errors to user-friendly messages
        switch (errorKey) {
          case "emailAlreadyInUse":
          case "invalidPhoneNumber":
          case "accountNumberAlreadyExist":
          case "invalidAccountNumber":
          case "subcompanySubscriptionLimitReached":
            setError(true);
            setErrorMessage(errorKey);
            break;
          default:
            setError(true);
            setErrorMessage("unexpectedError");
            break;
        }
      } else {
        console.error("Network or other error:", error.message);
        setError(true);
        setErrorMessage("networkError");
      }
      setLoadingModal(false);
    }
  };

  const handleCancelAddSubCompany = () => {
    setShowAreYouSure(false);
    setError("");
    setErrorMessage("");
    setAddSubCompanyModal(false);
    setAddBankAccountFields((prev) => ({
      visible: true,
      count: 0,
    }));
  };

  const handleAddBankAccount = () => {
    setAddBankAccountFields((prev) => ({
      visible: true,
      count: prev.count + 1,
    }));
  };

  const handleBankAccount = (bankAccounts) => {
    setNewSubCompanyFields((prev) => ({ ...prev, bankAccounts }));
  };

  const handleEditBankAccount = (bankAccounts) => {
    setSubCompanyFields((prev) => ({ ...prev, bankAccounts }));
  };

  const handleChangeAdditionalInfo = (e) => {
    const { name, value, type } = e.target;

    setAdditionalInfoState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <div className="e-container">
      <PageWrapper
          style={{ direction: currentDirection }}


      >


        <div className="users-title-section">
          <h4 className="page--title">
            {t("subCompanies", { defaultValue: "subCompanies" })}
          </h4>

          {!loading && userData?.userId ? (
            <CustomButton
              title={t("createSubCompany")}
              variant="blank"
              icon='addP'
              iconSize={20}
              onClick={openAddSubCompanyModal}
            />
          ) : null}
        </div>

        {loading ? (
          <Loader />
        ) : (
          <>

            <CustomInput
              name="subCompanyName"
              value={searchTerm}
              placeholder={searchTerm ? "" : t("search")}
              onChange={(e) => setSearchTerm(e.target.value)}
            />

            {filteredSubCompanies.length === 0 ? (
              <p>{t("noSubCompaniesFound")}</p>
            ) : (
              <>
                <ul
                  className="users-list"
                  style={{ direction: currentDirection }}
                >
                  {filteredSubCompanies.map((subCompany) => (
                    <li
                      className="user-list-item"
                      key={subCompany.id}
                      onClick={() => openSubCompanyModal(subCompany)}
                      style={{ cursor: "pointer" }}
                    >
                      <p className="user-username">
                        {currentDirection === "rtl"
                          ? subCompany.nameInAr || subCompany?.name
                          : subCompany?.name}
                      </p>
                    </li>
                  ))}
                </ul>

                <section className="pagination">
                  <div className="pagination-buttons">
                    <CustomButton
                      variant="blank"
                      title={t("previous")}
                      onClick={() => setCurrentPage((prev) => prev - 1)}
                      disabled={currentPage === 1}
                      icon={
                        currentDirection === "ltr" ? 'previous' : 'next'
                      }
                      iconSize={15}
                    />
                    <span className="pagination-location">
                      {t("page")}: {currentPage} - {totalPages}
                    </span>
                    <CustomButton
                      title={t("next")}
                      variant="blank"
                      onClick={() => setCurrentPage((prev) => prev + 1)}
                      disabled={currentPage === totalPages}
                      icon={
                        currentDirection === "ltr" ? 'next' : 'previous'
                      }
                      iconSize={15}
                      reverseIcon
                    />
                  </div>

                  <div className="pagination-buttons">
                    <span className="pagination-location">
                      {t("totalNumber")}: {totalRecords}
                    </span>
                  </div>
                </section>
              </>
            )}
          </>
        )}

        {/* Edit SubCompany Modal */}
        {subCompanyModal && (
          <Modal
            title={isEditing ? t("editSubCompany") : t("subCompany")}
            onClose={isEditing ? handleAttemptCancelUpdate : handleCancel}
            footer={
              <>
                {loadingModal ? <Loader /> : null}
                <section className="edit-user-actions">
                  {isEditing ? (
                    <>
                      <CustomButton
                        onClick={handleSaveSubCompany}
                        title={t("confirm")}
                        icon='save'
                        iconSize={16}
                        disabled={loadingModal}
                      />
                      <CustomButton
                        title={t("cancel")}
                        onClick={() => setIsEditing(false)}
                        variant="blank"
                        icon='close'
                        iconSize={14}
                      />
                    </>
                  ) : (
                    <>
                      <CustomButton
                        variant="blank"
                        title={t("edit")}
                        onClick={() => setIsEditing(true)}
                        icon='edit'
                        iconSize={18}
                      />
                    </>
                  )}
                </section>
              </>
            }
          >
            <div className="o-column o-column--gap-size_300">
              {isEditing ? (
                <>
                  {error ? (
                    <ErrorBox>
                      {t(errorMessage)}
                      {duplicateAccountNumber ? (
                        <span className="bold-text">
                          {duplicateAccountNumber}
                        </span>
                      ) : null}
                    </ErrorBox>
                  ) : null}
                  <div className="o-column o-column--gap-size_100">
                    <span>{t("companyNameInEn")}: </span>
                    <CustomInput
                      name="companyNameInEn"
                      value={subCompanyFields.companyName || ""}
                      onChange={(e) => handleInputChange(e, "companyName")}
                    />
                  </div>
                  <div className="o-column o-column--gap-size_100">
                    <span>{t("companyNameInAr")}: </span>
                    <CustomInput
                      name="nameInAr"
                      value={subCompanyFields?.nameInAr || ""}
                      onChange={(e) => handleInputChange(e, "nameInAr")}
                    />
                  </div>
                  <div className="o-column o-column--gap-size_100">
                    <span>{t("addressInEn")}: </span>
                    <CustomInput
                      name="address"
                      value={subCompanyFields?.address || ""}
                      onChange={(e) => handleInputChange(e, "address")}
                    />
                  </div>

                  <div className="o-column o-column--gap-size_100">
                    <span>{t("nearestLandMark")}: </span>
                    <CustomInput
                      name="nearestLandmark"
                      value={subCompanyFields?.nearestLandmark}
                      onChange={(e) => handleInputChange(e, "nearestLandmark")}
                    />
                  </div>
                  <div className="o-column o-column--gap-size_100">
                    <span>{t("city")}: </span>
                    <CustomInput
                      name="city"
                      value={subCompanyFields.city || ""}
                      onChange={(e) => handleInputChange(e, "city")}
                    />
                  </div>
                  <div className="o-column o-column--gap-size_100">
                    <span>{t("country")}: </span>
                    <CustomInput
                      name="country"
                      value={subCompanyFields.country || ""}
                      onChange={(e) => handleInputChange(e, "country")}
                    />
                  </div>
                  <div className="o-column o-column--gap-size_100">
                    <span>{t("website")}: </span>
                    <CustomInput
                      name="website"
                      value={subCompanyFields.website || ""}
                      onChange={(e) => handleInputChange(e, "website")}
                    />
                  </div>
                  <div className="o-column o-column--gap-size_100">
                    <span>{t("email")}: </span>
                    <CustomInput
                      name="email"
                      value={subCompanyFields.email || ""}
                      onChange={(e) => handleInputChange(e, "email")}
                    />
                  </div>
                  <div className="o-column o-column--gap-size_100">
                    <span>{t("phoneNumber")}: </span>
                    <CustomInput
                      name="phoneNumber"
                      value={subCompanyFields.phoneNumber || ""}
                      onChange={(e) => handleInputChange(e, "phoneNumber")}
                    />
                  </div>
                  <div className="o-column o-column--gap-size_100">
                    <span>{t("idNumber")}: </span>
                    <CustomInput
                      name="idNumber"
                      value={subCompanyFields.idNumber || ""}
                      onChange={(e) => handleInputChange(e, "idNumber")}
                    />
                  </div>

                  <div className="o-column o-column--gap-size_100">
                    <span>{t("customsCode")}: </span>
                    <CustomInput
                      name="customsCode"
                      value={subCompanyFields.customsCode || ""}
                      onChange={(e) => handleInputChange(e, "customsCode")}
                    />
                  </div>
                  <SectionDivider title="extraInformation" noMargin={true} />

                  <CollapsibleCard
                    title={t("additionalInfo")}
                    body={
                      <section className="o-column o-column--gap-size_200">
                        <div className="edit-user-entity">
                          <span>{t("addressInAr")}: </span>
                          <CustomInput
                            name="addressInAr"
                            value={
                              subCompanyFields?.compSupAdditionalInfo
                                ?.addressInAr ?? ""
                            }
                            onChange={(e) =>
                              handleNestedInputChange(e, "addressInAr")
                            }
                          />
                        </div>

                        <div className="edit-user-entity">
                          <span>{t("countryCode")}: </span>
                          <CustomInput
                            name="countryCode"
                            value={
                              subCompanyFields?.compSupAdditionalInfo
                                ?.countryCode ?? ""
                            }
                            onChange={(e) =>
                              handleNestedInputChange(e, "countryCode")
                            }
                          />
                        </div>

                        <div className="edit-user-entity">
                          <span>{t("commercialCompanyType")}: </span>
                          <CustomInput
                            name="commercialCompanyType"
                             value={
                              subCompanyFields?.compSupAdditionalInfo
                                ?.commercialCompanyType ?? ""
                            }
                            onChange={(e) =>
                              handleNestedInputChange(
                                e,
                                "commercialCompanyType"
                              )
                            }
                          />
                        </div>

                        <div className="edit-user-entity">
                          <span>{t("certificateIssueDate")}: </span>
                          <CustomInput
                            type="date"
                            name="certificateIssueDate"
                            value={formatDate(
                              subCompanyFields?.compSupAdditionalInfo
                                ?.certificateIssueDate ?? ""
                            )}
                            onChange={(e) =>
                              handleNestedInputChange(e, "certificateIssueDate")
                            }
                          />
                        </div>

                        <div className="edit-user-entity">
                          <span>{t("registrationNumber")}: </span>
                          <CustomInput
                            name="registrationNumber"
                            value={
                              subCompanyFields?.compSupAdditionalInfo
                                ?.registrationNumber ?? ""
                            }
                            onChange={(e) =>
                              handleNestedInputChange(e, "registrationNumber")
                            }
                          />
                        </div>

                        <div className="edit-user-entity">
                          <span>{t("originatorType")}: </span>
                          <CustomInput
                            name="originatorType"
                            value={
                              subCompanyFields?.compSupAdditionalInfo
                                ?.originatorType ?? ""
                            }
                            onChange={(e) =>
                              handleNestedInputChange(e, "originatorType")
                            }
                          />
                        </div>

                        <div className="edit-user-entity">
                          <span>{t("businessSector")}: </span>
                          <CustomInput
                            name="BusinessSector"
                            value={
                              subCompanyFields?.compSupAdditionalInfo
                                ?.BusinessSector ?? ""
                            }
                            onChange={(e) =>
                              handleNestedInputChange(e, "BusinessSector")
                            }
                          />
                        </div>

                        <div className="edit-user-entity">
                          <span>{t("typeOfGoods")}: </span>
                          <CustomInput
                            name="typeOfGoods"
                            value={
                              subCompanyFields?.compSupAdditionalInfo
                                ?.typeOfGoods ?? ""
                            }
                            onChange={(e) =>
                              handleNestedInputChange(e, "typeOfGoods")
                            }
                          />
                        </div>

                        <div className="edit-user-entity">
                          <span>{t("generalPurpose")}: </span>
                          <CustomInput
                            name="generalPurpose"
                            value={
                              subCompanyFields?.compSupAdditionalInfo
                                ?.generalPurpose ?? ""
                            }
                            onChange={(e) =>
                              handleNestedInputChange(e, "generalPurpose")
                            }
                          />
                        </div>

                        <div className="edit-user-entity">
                          <span>{t("purposeDetails")}: </span>
                          <CustomInput
                            name="purposeDetails"
                            value={
                              subCompanyFields?.compSupAdditionalInfo
                                ?.purposeDetails ?? ""
                            }
                            onChange={(e) =>
                              handleNestedInputChange(e, "purposeDetails")
                            }
                          />
                        </div>

                        <div className="edit-user-entity">
                          <span>{t("supplier1")}: </span>
                          <CustomInput
                            name="supplier1"
                            value={
                              subCompanyFields?.compSupAdditionalInfo
                                ?.supplier1 ?? ""
                            }
                            onChange={(e) =>
                              handleNestedInputChange(e, "supplier1")
                            }
                          />
                        </div>

                        <div className="edit-user-entity">
                          <span>{t("supplier2")}: </span>
                          <CustomInput
                            name="supplier2"
                            value={
                              subCompanyFields?.compSupAdditionalInfo
                                ?.supplier2 ?? ""
                            }
                            onChange={(e) =>
                              handleNestedInputChange(e, "supplier2")
                            }
                          />
                        </div>

                        <div className="edit-user-entity">
                          <span>{t("supplier3")}: </span>
                          <CustomInput
                            name="supplier3"
                            value={
                              subCompanyFields?.compSupAdditionalInfo
                                ?.supplier3 ?? ""
                            }
                            onChange={(e) =>
                              handleNestedInputChange(e, "supplier3")
                            }
                          />
                        </div>

                        <div className="edit-user-entity">
                          <span>{t("estimatedPaymentsCountPerQuarter")}: </span>
                          <CustomInput
                            name="estimatedPaymentsCountPerQuarter"
                            value={
                              subCompanyFields?.compSupAdditionalInfo
                                ?.estimatedPaymentsCountPerQuarter ?? ""
                            }
                            onChange={(e) =>
                              handleNestedInputChange(
                                e,
                                "estimatedPaymentsCountPerQuarter"
                              )
                            }
                          />
                        </div>

                        <div className="edit-user-entity">
                          <span>{t("estimatedPaymentsValuePerQuarter")}: </span>
                          <CustomInput
                            name="estimatedPaymentsValuePerQuarter"
                            value={
                              subCompanyFields?.compSupAdditionalInfo
                                ?.estimatedPaymentsValuePerQuarter ?? ""
                            }
                            onChange={(e) =>
                              handleNestedInputChange(
                                e,
                                "estimatedPaymentsValuePerQuarter"
                              )
                            }
                          />
                        </div>

                        <div className="edit-user-entity">
                          <span>{t("numberOfEmployees")}: </span>
                          <CustomInput
                            name="numberOfEmployees"
                            value={
                              subCompanyFields?.compSupAdditionalInfo
                                ?.numberOfEmployees ?? ""
                            }
                            onChange={(e) =>
                              handleNestedInputChange(e, "numberOfEmployees")
                            }
                          />
                        </div>

                        <div className="edit-user-entity">
                          <span>{t("annualRevenue")}: </span>
                          <CustomInput
                            name="annualRevenue"
                            value={
                              subCompanyFields?.compSupAdditionalInfo
                                ?.annualRevenue ?? ""
                            }
                            onChange={(e) =>
                              handleNestedInputChange(e, "annualRevenue")
                            }
                          />
                        </div>

                        {/* <SectionDividerWithNoLine title="significantParties" /> */}

                        <SectionDivider title="seniorManagingOfficial" />

                        <div className="edit-user-entity">
                          <span>{t("sFirstNameInAr")}: </span>
                          <CustomInput
                            name="sFirstNameInAr"
                            value={
                              subCompanyFields?.compSupAdditionalInfo
                                ?.sFirstNameInAr ?? ""
                            }
                            onChange={(e) =>
                              handleNestedInputChange(e, "sFirstNameInAr")
                            }
                          />
                        </div>

                        <div className="edit-user-entity">
                          <span>{t("sLastNameInAr")}: </span>
                          <CustomInput
                            name="sLastNameInAr"
                            value={
                              subCompanyFields?.compSupAdditionalInfo
                                ?.sLastNameInAr ?? ""
                            }
                            onChange={(e) =>
                              handleNestedInputChange(e, "sLastNameInAr")
                            }
                          />
                        </div>

                        <div className="edit-user-entity">
                          <span>{t("firstNameInEn")}: </span>
                          <CustomInput
                            name="sFirstName"
                            value={
                              subCompanyFields?.compSupAdditionalInfo
                                ?.sFirstName ?? ""
                            }
                            onChange={(e) =>
                              handleNestedInputChange(e, "sFirstName")
                            }
                          />
                        </div>

                        <div className="edit-user-entity">
                          <span>{t("lastNameInEn")}: </span>
                          <CustomInput
                            name="sLastName"
                            value={
                              subCompanyFields?.compSupAdditionalInfo
                                ?.sLastName ?? ""
                            }
                            onChange={(e) =>
                              handleNestedInputChange(e, "sLastName")
                            }
                          />
                        </div>

                        <div className="edit-user-entity">
                          <span>{t("sDateOfBirth")}: </span>
                          <CustomInput
                            type="date"
                            name="sDateOfBirth"
                            value={formatDate(
                              subCompanyFields?.compSupAdditionalInfo
                                ?.sDateOfBirth ?? ""
                            )}
                            onChange={(e) =>
                              handleNestedInputChange(e, "sDateOfBirth")
                            }
                          />
                        </div>

                        <div className="edit-user-entity">
                          <span>{t("sPhoneNumber")}: </span>
                          <CustomInput
                            name="sPhoneNumber"
                            value={
                              subCompanyFields?.compSupAdditionalInfo
                                ?.sPhoneNumber ?? ""
                            }
                            onChange={(e) =>
                              handleNestedInputChange(e, "sPhoneNumber")
                            }
                          />
                        </div>

                        <div className="edit-user-entity">
                          <span>{t("sAddress")}: </span>
                          <CustomInput
                            name="sAddress"
                            value={
                              subCompanyFields?.compSupAdditionalInfo
                                ?.sAddress ?? ""
                            }
                            onChange={(e) =>
                              handleNestedInputChange(e, "sAddress")
                            }
                          />
                        </div>

                        <div className="edit-user-entity">
                          <span>{t("sCity")}: </span>
                          <CustomInput
                            name="sCity"
                            value={
                              subCompanyFields?.compSupAdditionalInfo?.sCity ??
                              ""
                            }
                            onChange={(e) =>
                              handleNestedInputChange(e, "sCity")
                            }
                          />
                        </div>

                        <div className="edit-user-entity">
                          <span>{t("sCountry")}: </span>
                          <CustomInput
                            name="sCountry"
                            value={
                              subCompanyFields?.compSupAdditionalInfo
                                ?.sCountry ?? ""
                            }
                            onChange={(e) =>
                              handleNestedInputChange(e, "sCountry")
                            }
                          />
                        </div>

                        <div className="edit-user-entity">
                          <span>{t("sPosition")}: </span>
                          <CustomInput
                            name="sPosition"
                            value={
                              subCompanyFields?.compSupAdditionalInfo
                                ?.sPosition ?? ""
                            }
                            onChange={(e) =>
                              handleNestedInputChange(e, "sPosition")
                            }
                          />
                        </div>

                        <div className="edit-user-entity">
                          <span>{t("sIsOwner")}: </span>
                          <CustomInput
                            name="sIsOwner"
                            value={
                              subCompanyFields?.compSupAdditionalInfo
                                ?.sIsOwner ?? ""
                            }
                            onChange={(e) =>
                              handleNestedInputChange(e, "sIsOwner")
                            }
                          />
                        </div>

                        <div className="edit-user-entity">
                          <span>{t("sOwnerPercentage")}: </span>
                          <CustomInput
                            name="sOwnerPercentage"
                            value={
                              subCompanyFields?.compSupAdditionalInfo
                                ?.sOwnerPercentage ?? ""
                            }
                            onChange={(e) =>
                              handleNestedInputChange(e, "sOwnerPercentage")
                            }
                          />
                        </div>

                        <div className="edit-user-entity">
                          <span>{t("sIsAuthorizedSignatory")}: </span>
                          <CustomInput
                            name="sIsAuthorizedSignatory"
                            value={
                              subCompanyFields?.compSupAdditionalInfo
                                ?.sIsAuthorizedSignatory ?? ""
                            }
                            onChange={(e) =>
                              handleNestedInputChange(
                                e,
                                "sIsAuthorizedSignatory"
                              )
                            }
                          />
                        </div>

                        <div className="edit-user-entity">
                          <span>{t("sidType")}: </span>
                          <CustomInput
                            name="sidType"
                            value={
                              subCompanyFields?.compSupAdditionalInfo
                                ?.sidType ?? ""
                            }
                            onChange={(e) =>
                              handleNestedInputChange(e, "sidType")
                            }
                          />
                        </div>

                        <SectionDividerWithNoLine title="authorizedSignatory" />

                        <div className="edit-user-entity">
                          <span>{t("aFirstNameInAr")}: </span>
                          <CustomInput
                            name="aFirstNameInAr"
                            value={
                              subCompanyFields?.compSupAdditionalInfo
                                ?.aFirstNameInAr ?? ""
                            }
                            onChange={(e) =>
                              handleNestedInputChange(e, "aFirstNameInAr")
                            }
                          />
                        </div>

                        <div className="edit-user-entity">
                          <span>{t("aLastNameInAr")}: </span>
                          <CustomInput
                            name="aLastNameInAr"
                            value={
                              subCompanyFields?.compSupAdditionalInfo
                                ?.aLastNameInAr ?? ""
                            }
                            onChange={(e) =>
                              handleNestedInputChange(e, "aLastNameInAr")
                            }
                          />
                        </div>

                        <div className="edit-user-entity">
                          <span>{t("firstNameInEn")}: </span>
                          <CustomInput
                            name="aFirstName"
                            value={
                              subCompanyFields?.compSupAdditionalInfo
                                ?.aFirstName ?? ""
                            }
                            onChange={(e) =>
                              handleNestedInputChange(e, "aFirstName")
                            }
                          />
                        </div>

                        <div className="edit-user-entity">
                          <span>{t("lastNameInEn")}: </span>
                          <CustomInput
                            name="aLastName"
                            value={
                              subCompanyFields?.compSupAdditionalInfo
                                ?.aLastName ?? ""
                            }
                            onChange={(e) =>
                              handleNestedInputChange(e, "aLastName")
                            }
                          />
                        </div>

                        <div className="edit-user-entity">
                          <span>{t("aDateOfBirth")}: </span>
                          <CustomInput
                            type="date"
                            name="aDateOfBirth"
                            value={formatDate(
                              subCompanyFields?.compSupAdditionalInfo
                                ?.aDateOfBirth ?? ""
                            )}
                            onChange={(e) =>
                              handleNestedInputChange(e, "aDateOfBirth")
                            }
                          />
                        </div>

                        <div className="edit-user-entity">
                          <span>{t("aPhoneNumber")}: </span>
                          <CustomInput
                            name="aPhoneNumber"
                            value={
                              subCompanyFields?.compSupAdditionalInfo
                                ?.aPhoneNumber ?? ""
                            }
                            onChange={(e) =>
                              handleNestedInputChange(e, "aPhoneNumber")
                            }
                          />
                        </div>

                        <div className="edit-user-entity">
                          <span>{t("aAddress")}: </span>
                          <CustomInput
                            name="aAddress"
                            value={
                              subCompanyFields?.compSupAdditionalInfo
                                ?.aAddress ?? ""
                            }
                            onChange={(e) =>
                              handleNestedInputChange(e, "aAddress")
                            }
                          />
                        </div>

                        <div className="edit-user-entity">
                          <span>{t("aCity")}: </span>
                          <CustomInput
                            name="aCity"
                            value={
                              subCompanyFields?.compSupAdditionalInfo?.aCity ??
                              ""
                            }
                            onChange={(e) =>
                              handleNestedInputChange(e, "aCity")
                            }
                          />
                        </div>

                        <div className="edit-user-entity">
                          <span>{t("aCountry")}: </span>
                          <CustomInput
                            name="aCountry"
                            value={
                              subCompanyFields?.compSupAdditionalInfo
                                ?.aCountry ?? ""
                            }
                            onChange={(e) =>
                              handleNestedInputChange(e, "aCountry")
                            }
                          />
                        </div>

                        <div className="edit-user-entity">
                          <span>{t("aIsOwner")}: </span>
                          <CustomInput
                            name="aIsOwner"
                            value={
                              subCompanyFields?.compSupAdditionalInfo
                                ?.aIsOwner ?? ""
                            }
                            onChange={(e) =>
                              handleNestedInputChange(e, "aIsOwner")
                            }
                          />
                        </div>

                        <div className="edit-user-entity">
                          <span>{t("aOwnerPercentage")}: </span>
                          <CustomInput
                            name="aOwnerPercentage"
                            value={
                              subCompanyFields?.compSupAdditionalInfo
                                ?.aOwnerPercentage ?? ""
                            }
                            onChange={(e) =>
                              handleNestedInputChange(e, "aOwnerPercentage")
                            }
                          />
                        </div>

                        <div className="edit-user-entity">
                          <span>{t("aIsAuthorizedSeniorManaging")}: </span>
                          <CustomInput
                            name="aIsAuthorizedSeniorManaging"
                            value={
                              subCompanyFields?.compSupAdditionalInfo
                                ?.aIsAuthorizedSeniorManaging ?? ""
                            }
                            onChange={(e) =>
                              handleNestedInputChange(
                                e,
                                "aIsAuthorizedSeniorManaging"
                              )
                            }
                          />
                        </div>

                        <div className="edit-user-entity">
                          <span>{t("aIdType")}: </span>
                          <CustomInput
                            name="aIdType"
                            value={
                              subCompanyFields?.compSupAdditionalInfo
                                ?.aIdType ?? ""
                            }
                            onChange={(e) =>
                              handleNestedInputChange(e, "aIdType")
                            }
                          />
                        </div>

                        <div className="edit-user-entity">
                          <span>{t("aIdNumber")}: </span>
                          <CustomInput
                            name="aIdNumber"
                            value={
                              subCompanyFields?.compSupAdditionalInfo
                                ?.aIdNumber ?? ""
                            }
                            onChange={(e) =>
                              handleNestedInputChange(e, "aIdNumber")
                            }
                          />
                        </div>
                      </section>
                    }
                    isEditing={isEditing}
                  />
                  <div>
                    <BankAccountSection
                      sendDataToParent={handleEditBankAccount}
                      data={selectedSubCompany?.bankAccount}
                      deleteUrl="api/subCompany"
                      refetchFunction={getSubCompanies}
                    />
                  </div>
                </>
              ) : (
                <>
                  <div className="view-user-entity">
                    <p>{t("companyName")}:</p>
                    <span>{selectedSubCompany?.name}</span>
                  </div>
                  <div className="view-user-entity">
                    <p>{t("companyNameInAr")}:</p>
                    <span>{selectedSubCompany?.nameInAr}</span>
                  </div>
                  <div className="view-user-entity">
                    <p>{t("addressInEn")}:</p>
                    <span>{selectedSubCompany?.address}</span>
                  </div>
                  <div className="view-user-entity">
                    <p>{t("nearestLandMark")}:</p>
                    <span>{selectedSubCompany?.nearestLandmark}</span>
                  </div>
                  <div className="view-user-entity">
                    <p>{t("country")}:</p>
                    <span>{selectedSubCompany?.country}</span>
                  </div>
                  <div className="view-user-entity">
                    <p>{t("city")}:</p>
                    <span>{selectedSubCompany?.city}</span>
                  </div>
                  <div className="view-user-entity">
                    <p>{t("website")}:</p>
                    <span>{selectedSubCompany?.website}</span>
                  </div>
                  <div className="view-user-entity">
                    <p>{t("email")}:</p>
                    <span>{selectedSubCompany?.email}</span>
                  </div>
                  <div className="view-user-entity">
                    <p>{t("phoneNumber")}:</p>
                    <span>{selectedSubCompany?.phoneNumber}</span>
                  </div>
                  <div className="view-user-entity">
                    <p>{t("idNumber")}:</p>
                    <span>{selectedSubCompany?.idNumber}</span>
                  </div>
                  <div className="view-user-entity">
                    <p>{t("customsCode")}:</p>
                    <span>{selectedSubCompany?.customsCode}</span>
                  </div>
                  <SectionDivider title="bankAccountInfo" />
                  <section className="o-column o-column--gap-size_500">
                    {selectedSubCompany?.bankAccount?.map((bankAccount) => (
                      <div>
                        <div className="view-user-entity">
                          <p>{t("bankName")}:</p>
                          <span>{bankAccount?.bank?.name}</span>
                        </div>
                        <div className="view-user-entity">
                          <p>{t("branch")}:</p>
                          <span>{bankAccount?.branch?.address}</span>
                        </div>
                        <div className="view-user-entity">
                          <p>{t("accountNumber")}:</p>
                          <span>{bankAccount?.accountNumber}</span>
                        </div>
                        <div className="view-user-entity">
                          <p>{t("accountCurrency")}:</p>
                          <span>{bankAccount?.accountCurrency}</span>
                        </div>
                        <div className="view-user-entity">
                          <p>{t("SWIFT")}:</p>
                          <span>{bankAccount?.swiftCode}</span>
                        </div>
                        <div className="view-user-entity">
                          <p>{t("IBAN")}:</p>
                          <span>{bankAccount?.iban}</span>
                        </div>
                      </div>
                    ))}
                  </section>

                  {selectedSubCompany.comSupAdditionalInfo && (
                    <>
                      <SectionDivider title="extraInformation" />
                      <section className="o-column o-column--gap-size_200">
                        <div className="view-user-entity">
                          <p>{t("addressInAr")}:</p>
                          <span>
                            {
                              selectedSubCompany?.comSupAdditionalInfo
                                ?.addressInAr
                            }
                          </span>
                        </div>

                        <div className="view-user-entity">
                          <p>{t("countryCode")}:</p>
                          <span>
                            {
                              selectedSubCompany?.comSupAdditionalInfo
                                ?.countryCode
                            }
                          </span>
                        </div>

                        <div className="view-user-entity">
                          <p>{t("commercialCompanyType")}:</p>
                          <span>
                            {
                              selectedSubCompany?.comSupAdditionalInfo
                                ?.commercialCompanyType
                            }
                          </span>
                        </div>

                        <div className="view-user-entity">
                          <p>{t("certificateIssueDate")}:</p>
                          <span>
                            {formatDate(
                              selectedSubCompany?.comSupAdditionalInfo
                                ?.certificateIssueDate
                            )}
                          </span>
                        </div>

                        <div className="view-user-entity">
                          <p>{t("registrationNumber")}:</p>
                          <span>
                            {
                              selectedSubCompany?.comSupAdditionalInfo
                                ?.registrationNumber
                            }
                          </span>
                        </div>

                        <div className="view-user-entity">
                          <p>{t("originatorType")}:</p>
                          <span>
                            {
                              selectedSubCompany?.comSupAdditionalInfo
                                ?.originatorType
                            }
                          </span>
                        </div>
                        <div className="view-user-entity">
                          <p>{t("businessSector")}:</p>
                          <span>
                            {
                              selectedSubCompany?.comSupAdditionalInfo
                                ?.BusinessSector
                            }
                          </span>
                        </div>

                        <div className="view-user-entity">
                          <p>{t("typeOfGoods")}:</p>
                          <span>
                            {
                              selectedSubCompany?.comSupAdditionalInfo
                                ?.typeOfGoods
                            }
                          </span>
                        </div>

                        <div className="view-user-entity">
                          <p>{t("generalPurpose")}:</p>
                          <span>
                            {
                              selectedSubCompany?.comSupAdditionalInfo
                                ?.generalPurpose
                            }
                          </span>
                        </div>

                        <div className="view-user-entity">
                          <p>{t("purposeDetails")}:</p>
                          <span>
                            {
                              selectedSubCompany?.comSupAdditionalInfo
                                ?.purposeDetails
                            }
                          </span>
                        </div>

                        <div className="view-user-entity">
                          <p>{t("supplier1")}:</p>
                          <span>
                            {
                              selectedSubCompany?.comSupAdditionalInfo
                                ?.supplier1
                            }
                          </span>
                        </div>

                        <div className="view-user-entity">
                          <p>{t("supplier2")}:</p>
                          <span>
                            {
                              selectedSubCompany?.comSupAdditionalInfo
                                ?.supplier2
                            }
                          </span>
                        </div>

                        <div className="view-user-entity">
                          <p>{t("supplier3")}:</p>
                          <span>
                            {
                              selectedSubCompany?.comSupAdditionalInfo
                                ?.supplier3
                            }
                          </span>
                        </div>

                        <div className="view-user-entity">
                          <p>{t("estimatedPaymentsCountPerQuarter")}:</p>
                          <span>
                            {
                              selectedSubCompany?.comSupAdditionalInfo
                                ?.estimatedPaymentsCountPerQuarter
                            }
                          </span>
                        </div>

                        <div className="view-user-entity">
                          <p>{t("estimatedPaymentsValuePerQuarter")}:</p>
                          <span>
                            {
                              selectedSubCompany?.comSupAdditionalInfo
                                ?.estimatedPaymentsValuePerQuarter
                            }
                          </span>
                        </div>

                        <div className="view-user-entity">
                          <p>{t("numberOfEmployees")}:</p>
                          <span>
                            {
                              selectedSubCompany?.comSupAdditionalInfo
                                ?.numberOfEmployees
                            }
                          </span>
                        </div>

                        <div className="view-user-entity">
                          <p>{t("annualRevenue")}:</p>
                          <span>
                            {
                              selectedSubCompany?.comSupAdditionalInfo
                                ?.annualRevenue
                            }
                          </span>
                        </div>

                        {/* Senior Manager */}

                        <SectionDivider title="significantParties" />

                        <SectionDividerWithNoLine title="seniorManagingOfficial" />

                        <div className="view-user-entity">
                          <p>{t("sFirstNameInAr")}:</p>
                          <span>
                            {
                              selectedSubCompany?.comSupAdditionalInfo
                                ?.sFirstNameInAr
                            }
                          </span>
                        </div>

                        <div className="view-user-entity">
                          <p>{t("sLastNameInAr")}:</p>
                          <span>
                            {
                              selectedSubCompany?.comSupAdditionalInfo
                                ?.sLastNameInAr
                            }
                          </span>
                        </div>

                        <div className="view-user-entity">
                          <p>{t("firstNameInEn")}:</p>
                          <span>
                            {
                              selectedSubCompany?.comSupAdditionalInfo
                                ?.sFirstName
                            }
                          </span>
                        </div>

                        <div className="view-user-entity">
                          <p>{t("lastNameInEn")}:</p>
                          <span>
                            {
                              selectedSubCompany?.comSupAdditionalInfo
                                ?.sLastName
                            }
                          </span>
                        </div>

                        <div className="view-user-entity">
                          <p>{t("sDateOfBirth")}:</p>
                          <span>
                            {formatDate(
                              selectedSubCompany?.comSupAdditionalInfo
                                ?.sDateOfBirth
                            )}
                          </span>
                        </div>

                        <div className="view-user-entity">
                          <p>{t("sPhoneNumber")}:</p>
                          <span>
                            {
                              selectedSubCompany?.comSupAdditionalInfo
                                ?.sPhoneNumber
                            }
                          </span>
                        </div>

                        <div className="view-user-entity">
                          <p>{t("sAddress")}:</p>
                          <span>
                            {selectedSubCompany?.comSupAdditionalInfo?.sAddress}
                          </span>
                        </div>

                        <div className="view-user-entity">
                          <p>{t("sCity")}:</p>
                          <span>
                            {selectedSubCompany?.comSupAdditionalInfo?.sCity}
                          </span>
                        </div>

                        <div className="view-user-entity">
                          <p>{t("sCountry")}:</p>
                          <span>
                            {selectedSubCompany?.comSupAdditionalInfo?.sCountry}
                          </span>
                        </div>

                        <div className="view-user-entity">
                          <p>{t("sPosition")}:</p>
                          <span>
                            {
                              selectedSubCompany?.comSupAdditionalInfo
                                ?.sPosition
                            }
                          </span>
                        </div>

                        <div className="view-user-entity">
                          <p>{t("sIsOwner")}:</p>
                          <span>
                            {selectedSubCompany?.comSupAdditionalInfo?.sIsOwner}
                          </span>
                        </div>

                        <div className="view-user-entity">
                          <p>{t("sOwnerPercentage")}:</p>
                          <span>
                            {
                              selectedSubCompany?.comSupAdditionalInfo
                                ?.sOwnerPercentage
                            }
                          </span>
                        </div>

                        <div className="view-user-entity">
                          <p>{t("sIsAuthorizedSignatory")}:</p>
                          <span>
                            {
                              selectedSubCompany?.comSupAdditionalInfo
                                ?.sIsAuthorizedSignatory
                            }
                          </span>
                        </div>

                        <div className="view-user-entity">
                          <p>{t("sidType")}:</p>
                          <span>
                            {selectedSubCompany?.comSupAdditionalInfo?.sidType}
                          </span>
                        </div>

                        {/* Authorized Signatory */}

                        <SectionDividerWithNoLine title="authorizedSignatory" />
                        <div className="view-user-entity">
                          <p>{t("aFirstNameInAr")}:</p>
                          <span>
                            {
                              selectedSubCompany?.comSupAdditionalInfo
                                ?.aFirstNameInAr
                            }
                          </span>
                        </div>

                        <div className="view-user-entity">
                          <p>{t("aLastNameInAr")}:</p>
                          <span>
                            {
                              selectedSubCompany?.comSupAdditionalInfo
                                ?.aLastNameInAr
                            }
                          </span>
                        </div>

                        <div className="view-user-entity">
                          <p>{t("firstNameInEn")}:</p>
                          <span>
                            {
                              selectedSubCompany?.comSupAdditionalInfo
                                ?.aFirstName
                            }
                          </span>
                        </div>

                        <div className="view-user-entity">
                          <p>{t("lastNameInEn")}:</p>
                          <span>
                            {
                              selectedSubCompany?.comSupAdditionalInfo
                                ?.aLastName
                            }
                          </span>
                        </div>

                        <div className="view-user-entity">
                          <p>{t("aDateOfBirth")}:</p>
                          <span>
                            {formatDate(
                              selectedSubCompany?.comSupAdditionalInfo
                                ?.aDateOfBirth
                            )}
                          </span>
                        </div>

                        <div className="view-user-entity">
                          <p>{t("aPhoneNumber")}:</p>
                          <span>
                            {
                              selectedSubCompany?.comSupAdditionalInfo
                                ?.aPhoneNumber
                            }
                          </span>
                        </div>

                        <div className="view-user-entity">
                          <p>{t("aAddress")}:</p>
                          <span>
                            {selectedSubCompany?.comSupAdditionalInfo?.aAddress}
                          </span>
                        </div>

                        <div className="view-user-entity">
                          <p>{t("aCity")}:</p>
                          <span>
                            {selectedSubCompany?.comSupAdditionalInfo?.aCity}
                          </span>
                        </div>

                        <div className="view-user-entity">
                          <p>{t("aCountry")}:</p>
                          <span>
                            {selectedSubCompany?.comSupAdditionalInfo?.aCountry}
                          </span>
                        </div>

                        <div className="view-user-entity">
                          <p>{t("aIsOwner")}:</p>
                          <span>
                            {selectedSubCompany?.comSupAdditionalInfo?.aIsOwner}
                          </span>
                        </div>

                        <div className="view-user-entity">
                          <p>{t("aOwnerPercentage")}:</p>
                          <span>
                            {
                              selectedSubCompany?.comSupAdditionalInfo
                                ?.aOwnerPercentage
                            }
                          </span>
                        </div>

                        <div className="view-user-entity">
                          <p>{t("aIsAuthorizedSeniorManaging")}:</p>
                          <span>
                            {
                              selectedSubCompany?.comSupAdditionalInfo
                                ?.aIsAuthorizedSeniorManaging
                            }
                          </span>
                        </div>

                        <div className="view-user-entity">
                          <p>{t("aIdType")}:</p>
                          <span>
                            {selectedSubCompany?.comSupAdditionalInfo?.aIdType}
                          </span>
                        </div>

                        <div className="view-user-entity">
                          <p>{t("aIdNumber")}:</p>
                          <span>
                            {
                              selectedSubCompany?.comSupAdditionalInfo
                                ?.aIdNumber
                            }
                          </span>
                        </div>
                      </section>
                    </>
                  )}
                </>
              )}
            </div>
          </Modal>
        )}

        {showUpdateAreYouSure && isEditing ? (
          <AreYouSureModal
            onClose={() => setShowUpdateAreYouSure(false)}
            onConfirm={() => handleCancel()}
            confirmIconType="whiteCheck"
            customMessage={t("areYouSureCancelUpdate")}
          />
        ) : null}

        {/* Add SubCompany Modal */}
        {addSubCompanyModal && (
          <Modal
            title={t("createSubCompany")}
            onClose={handleAttemptCancel}
            error={t(errorMessage)}
            footer={
              <>
                {loadingModal ? <Loader /> : null}
                <section className="edit-user-actions">
                  <CustomButton
                    title={t("confirm")}
                    onClick={handleCreateSubCompany}
                    icon='save'
                    iconSize={16}
                    disabled={loadingModal}
                  />
                  <CustomButton
                    title={t("cancel")}
                    onClick={handleCancelAddSubCompany}
                    variant="blank"
                    icon='close'
                    iconSize={14}
                  />
                </section>
              </>
            }
          >
            <form
              className="o-column o-column--gap-size_400"
              onSubmit={handleCreateSubCompany}
            >
              {error && (
                <div className="o-row o-row--horizontal-align_center o-row--vertical-align_center">
                  <ErrorBox>{t(errorMessage)}</ErrorBox>
                </div>
              )}

              <div className="o-column o-column--gap-size_300">
                <div className="o-column o-column--gap-size_100">
                  <span>{t("companyName")}: </span>
                  <CustomInput
                    name="companyName"
                    value={newSubCompanyFields.companyName}
                    onChange={(e) =>
                      handleNewSubCompanyInputChange(e, "companyName")
                    }
                    errorText={emptyInputField}
                  />
                </div>
                <div className="o-column o-column--gap-size_100">
                  <span>{t("companyNameInAr")}: </span>
                  <CustomInput
                    name="nameInAr"
                    value={newSubCompanyFields?.nameInAr}
                    onChange={(e) =>
                      handleNewSubCompanyInputChange(e, "nameInAr")
                    }
                  />
                </div>
                <div className="o-column o-column--gap-size_100">
                  <span>{t("addressInEn")}: </span>
                  <CustomInput
                    name="address"
                    value={newSubCompanyFields?.address}
                    onChange={(e) =>
                      handleNewSubCompanyInputChange(e, "address")
                    }
                  />
                </div>

                <div className="o-column o-column--gap-size_100">
                  <span>{t("nearestLandMark")}: </span>
                  <CustomInput
                    name="nearestLandmark"
                    value={newSubCompanyFields?.nearestLandmark}
                    onChange={(e) =>
                      handleNewSubCompanyInputChange(e, "nearestLandmark")
                    }
                  />
                </div>

                <div className="o-column o-column--gap-size_100">
                  <span>{t("city")}: </span>
                  <CustomInput
                    name="city"
                    value={newSubCompanyFields.city || ""}
                    onChange={(e) => handleNewSubCompanyInputChange(e, "city")}
                  />
                </div>
                <div className="o-column o-column--gap-size_100">
                  <span>{t("country")}: </span>
                  <CustomInput
                    name="country"
                    value={newSubCompanyFields.country || ""}
                    onChange={(e) =>
                      handleNewSubCompanyInputChange(e, "country")
                    }
                  />
                </div>
                <div className="o-column o-column--gap-size_100">
                  <span>{t("website")}: </span>
                  <CustomInput
                    name="website"
                    value={newSubCompanyFields.website}
                    onChange={(e) =>
                      handleNewSubCompanyInputChange(e, "website")
                    }
                  />
                </div>
                <div className="o-column o-column--gap-size_100">
                  <span>{t("email")}: </span>
                  <CustomInput
                    name="email"
                    value={newSubCompanyFields.email}
                    onChange={(e) => handleNewSubCompanyInputChange(e, "email")}
                  />
                </div>
                <div className="o-column o-column--gap-size_100">
                  <span>{t("phoneNumber")}: </span>
                  <CustomInput
                    name="phoneNumber"
                    value={newSubCompanyFields.phoneNumber}
                    onChange={(e) =>
                      handleNewSubCompanyInputChange(e, "phoneNumber")
                    }
                  />
                </div>
                <div className="o-column o-column--gap-size_100">
                  <span>{t("idNumber")}: </span>
                  <CustomInput
                    name="idNumber"
                    value={newSubCompanyFields.idNumber}
                    onChange={(e) =>
                      handleNewSubCompanyInputChange(e, "idNumber")
                    }
                  />
                </div>

                <div className="o-column o-column--gap-size_100">
                  <span>{t("customsCode")}: </span>
                  <CustomInput
                    name="customsCode"
                    value={newSubCompanyFields.customsCode}
                    onChange={(e) =>
                      handleNewSubCompanyInputChange(e, "customsCode")
                    }
                  />
                </div>
              </div>

              <DashboardSection title={"additionalInfoSection"}>
                <SubCompanyAdditionalInfoSection
                  additionalInfoState={additionalInfoState}
                  handleChangeAdditionalInfo={handleChangeAdditionalInfo}
                  isEditing={true}
                />
              </DashboardSection>

              {addBankAccountFields.visible ? (
                <BankAccountSection
                  sendDataToParent={handleBankAccount}
                  refetchFunction={getSubCompanies}
                />
              ) : (
                <div className="o-column o-column--vertical-align_end">
                  <CustomButton
                    onClick={handleAddBankAccount}
                    variant="blank"
                    icon='addP'
                    title={t("addBankAccount")}
                  />
                </div>
              )}
            </form>
          </Modal>
        )}

        {showAreYouSure ? (
          <AreYouSureModal
            shouldCloseModal={shouldCloseModal({
              ...newSubCompanyFields,
              bankAccounts: null,
              ...additionalInfoState,
            })}
            onClose={() => setShowAreYouSure(false)}
            onConfirm={handleCancelAddSubCompany}
            confirmIconType="whiteCheck"
          />
        ) : null}
      </PageWrapper>
    </div>
  );
}
